!(function (e) {
  var t = {};
  function n(o) {
    if (t[o]) return t[o].exports;
    var i = (t[o] = { i: o, l: !1, exports: {} });
    return e[o].call(i.exports, i, i.exports, n), (i.l = !0), i.exports;
  }
  (n.m = e),
    (n.c = t),
    (n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o });
    }),
    (n.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (n.t = function (e, t) {
      if ((1 & t && (e = n(e)), 8 & t)) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (
        (n.r(o),
        Object.defineProperty(o, "default", { enumerable: !0, value: e }),
        2 & t && "string" != typeof e)
      )
        for (var i in e)
          n.d(
            o,
            i,
            function (t) {
              return e[t];
            }.bind(null, i)
          );
      return o;
    }),
    (n.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return n.d(t, "a", t), t;
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.p = ""),
    n((n.s = 0));
})([
  function (e, t, n) {
    n(2), (e.exports = n(1));
  },
  function (e, t, n) {},
  function (e, t, n) {
    "use strict";
    n.r(t);
    function o(e, t) {
      (this.container = (function (e) {
        if (!(e instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === e.getAttribute("data-section-id"))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute."
          );
        return e;
      })(e)),
        (this.id = e.getAttribute("data-section-id")),
        (this.extensions = []),
        Object.assign(
          this,
          (function (e) {
            if ((void 0 !== e && "object" != typeof e) || null === e)
              throw new TypeError(
                "Theme Sections: The properties object provided is not a valid"
              );
            return e;
          })(t)
        ),
        this.onLoad();
    }
    (o.prototype = {
      onLoad: Function.prototype,
      onUnload: Function.prototype,
      onSelect: Function.prototype,
      onDeselect: Function.prototype,
      onBlockSelect: Function.prototype,
      onBlockDeselect: Function.prototype,
      extend: function (e) {
        this.extensions.push(e);
        var t = Object.assign({}, e);
        delete t.init,
          Object.assign(this, t),
          "function" == typeof e.init && e.init.apply(this);
      },
    }),
      "function" != typeof Object.assign &&
        Object.defineProperty(Object, "assign", {
          value: function (e) {
            if (null == e)
              throw new TypeError("Cannot convert undefined or null to object");
            for (var t = Object(e), n = 1; n < arguments.length; n++) {
              var o = arguments[n];
              if (null != o)
                for (var i in o)
                  Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
            }
            return t;
          },
          writable: !0,
          configurable: !0,
        });
    (window.Shopify = window.Shopify || {}),
      (window.Shopify.theme = window.Shopify.theme || {}),
      (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
    var i = (window.Shopify.theme.sections.registered =
        window.Shopify.theme.sections.registered || {}),
      s = (window.Shopify.theme.sections.instances =
        window.Shopify.theme.sections.instances || []);
    function a(e, t) {
      (e = r(e)),
        void 0 === t && (t = document.querySelectorAll("[data-section-type]")),
        (t = d(t)),
        e.forEach(function (e) {
          var n = i[e];
          void 0 !== n &&
            (t = t.filter(function (t) {
              return (
                !(c(t).length > 0) &&
                null !== t.getAttribute("data-section-type") &&
                (t.getAttribute("data-section-type") !== e ||
                  (s.push(new n(t)), !1))
              );
            }));
        });
    }
    function c(e) {
      var t = [];
      if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var n = e[0];
      if (e instanceof Element || n instanceof Element)
        d(e).forEach(function (e) {
          t = t.concat(
            s.filter(function (t) {
              return t.container === e;
            })
          );
        });
      else if ("string" == typeof e || "string" == typeof n) {
        r(e).forEach(function (e) {
          t = t.concat(
            s.filter(function (t) {
              return t.type === e;
            })
          );
        });
      }
      return t;
    }
    function l(e) {
      for (var t, n = 0; n < s.length; n++)
        if (s[n].id === e) {
          t = s[n];
          break;
        }
      return t;
    }
    function r(e) {
      return (
        "*" === e
          ? (e = Object.keys(i))
          : "string" == typeof e
          ? (e = [e])
          : e.constructor === o
          ? (e = [e.prototype.type])
          : Array.isArray(e) &&
            e[0].constructor === o &&
            (e = e.map(function (e) {
              return e.prototype.type;
            })),
        (e = e.map(function (e) {
          return e.toLowerCase();
        }))
      );
    }
    function d(e) {
      return (
        NodeList.prototype.isPrototypeOf(e) && e.length > 0
          ? (e = Array.prototype.slice.call(e))
          : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) ||
            null === e
          ? (e = [])
          : !Array.isArray(e) && e instanceof Element && (e = [e]),
        e
      );
    }
    window.Shopify.designMode &&
      (document.addEventListener("shopify:section:load", function (e) {
        var t = e.detail.sectionId,
          n = e.target.querySelector('[data-section-id="' + t + '"]');
        null !== n && a(n.getAttribute("data-section-type"), n);
      }),
      document.addEventListener("shopify:section:unload", function (e) {
        var t = e.detail.sectionId,
          n = e.target.querySelector('[data-section-id="' + t + '"]');
        "object" == typeof c(n)[0] &&
          c(n).forEach(function (e) {
            var t = s
              .map(function (e) {
                return e.id;
              })
              .indexOf(e.id);
            s.splice(t, 1), e.onUnload();
          });
      }),
      document.addEventListener("shopify:section:select", function (e) {
        var t = l(e.detail.sectionId);
        "object" == typeof t && t.onSelect(e);
      }),
      document.addEventListener("shopify:section:deselect", function (e) {
        var t = l(e.detail.sectionId);
        "object" == typeof t && t.onDeselect(e);
      }),
      document.addEventListener("shopify:block:select", function (e) {
        var t = l(e.detail.sectionId);
        "object" == typeof t && t.onBlockSelect(e);
      }),
      document.addEventListener("shopify:block:deselect", function (e) {
        var t = l(e.detail.sectionId);
        "object" == typeof t && t.onBlockDeselect(e);
      }));
    if (!window.tns) {
      var g = document.createElement("script");
      (g.type = "text/javascript"),
        (g.src =
          "https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.2/min/tiny-slider.js"),
        document.body.appendChild(g);
      var u = document.createElement("link");
      (u.rel = "stylesheet"),
        (u.type = "text/css"),
        (u.href =
          "https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.3/tiny-slider.css"),
        document.head.appendChild(u);
    }
    var p = function (e) {
        return e > 1e9
          ? "".concat((e / 1e9).toFixed(1), "B")
          : e > 1e6
          ? "".concat((e / 1e6).toFixed(1), "M")
          : e > 1e3
          ? "".concat((e / 1e3).toFixed(1), "K")
          : e;
      },
      w = function (e, t) {
        var n = new Date(e),
          o = n.getFullYear(),
          i = "".concat(o),
          s = n.getMonth() + 1,
          a = "".concat(s < 10 ? "0" : "").concat(s),
          c = n.getDate(),
          l = "".concat(c < 10 ? "0" : "").concat(c);
        switch (t) {
          case "YYYY-MM-DD":
            return "".concat(i, "-").concat(a, "-").concat(l);
          case "YYYY/MM/DD":
            return "".concat(i, "/").concat(a, "/").concat(l);
          case "MM/DD/YYYY":
            return "".concat(a, "/").concat(l, "/").concat(i);
          default:
            return "".concat(i, "-").concat(a, "-").concat(l);
        }
      };
    var v =
        '\n<svg\n  height="512pt"\n  viewBox="0 -77 512.00213 512"\n  width="512pt"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <path\n    d="m501.453125 56.09375c-5.902344-21.933594-23.195313-39.222656-45.125-45.128906-40.066406-10.964844-200.332031-10.964844-200.332031-10.964844s-160.261719 0-200.328125 10.546875c-21.507813 5.902344-39.222657 23.617187-45.125 45.546875-10.542969 40.0625-10.542969 123.148438-10.542969 123.148438s0 83.503906 10.542969 123.148437c5.90625 21.929687 23.195312 39.222656 45.128906 45.128906 40.484375 10.964844 200.328125 10.964844 200.328125 10.964844s160.261719 0 200.328125-10.546875c21.933594-5.902344 39.222656-23.195312 45.128906-45.125 10.542969-40.066406 10.542969-123.148438 10.542969-123.148438s.421875-83.507812-10.546875-123.570312zm0 0"\n    fill="#f00"\n  />\n  <path d="m204.96875 256 133.269531-76.757812-133.269531-76.757813zm0 0" fill="#fff" />\n</svg>\n',
      m =
        '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 329.26933 329"\n>\n  <g>\n    <path\n      xmlns="http://www.w3.org/2000/svg"\n      d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"\n      fill="#ffffff"\n      data-original="#000000"\n    />\n  </g>\n</svg>\n',
      h =
        '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 512 512"\n>\n  <g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M117.333,10.667h-64C23.936,10.667,0,34.603,0,64v170.667C0,264.064,23.936,288,53.333,288h96V21.461    C140.395,14.72,129.344,10.667,117.333,10.667z"\n          fill="#888888"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M512,208c0-18.496-10.581-34.731-26.347-42.667c3.285-6.549,5.013-13.803,5.013-21.333    c0-18.517-10.603-34.752-26.368-42.688c4.885-9.728,6.315-20.928,3.861-32.043C463.381,47.659,443.051,32,419.819,32H224    c-13.995,0-35.968,4.416-53.333,12.608v228.651l2.56,1.301l61.44,133.12V480c0,3.243,1.472,6.315,3.989,8.341    c0.683,0.512,16.512,12.992,38.677,12.992c24.683,0,64-39.061,64-85.333c0-29.184-10.453-65.515-16.981-85.333h131.776    c28.715,0,53.141-21.248,55.637-48.363c1.387-15.211-3.691-29.824-13.653-40.725C506.923,232.768,512,220.821,512,208z"\n          fill="#888888"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n  </g>\n</svg>\n',
      y =
        '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 512 512"\n>\n  <g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M53.333,224C23.936,224,0,247.936,0,277.333V448c0,29.397,23.936,53.333,53.333,53.333h64    c12.011,0,23.061-4.053,32-10.795V224H53.333z"\n          fill="#888888"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M512,304c0-12.821-5.077-24.768-13.888-33.579c9.963-10.901,15.04-25.515,13.653-40.725    c-2.496-27.115-26.923-48.363-55.637-48.363H324.352c6.528-19.819,16.981-56.149,16.981-85.333c0-46.272-39.317-85.333-64-85.333    c-22.165,0-37.995,12.48-38.677,12.992c-2.517,2.027-3.989,5.099-3.989,8.341v72.341l-61.44,133.099l-2.56,1.301v228.651    C188.032,475.584,210.005,480,224,480h195.819c23.232,0,43.563-15.659,48.341-37.269c2.453-11.115,1.024-22.315-3.861-32.043    c15.765-7.936,26.368-24.171,26.368-42.688c0-7.552-1.728-14.784-5.013-21.333C501.419,338.731,512,322.496,512,304z"\n          fill="#888888"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n  </g>\n</svg>\n',
      f = function () {
        var e = document.createElement("DIV");
        return (e.className = "divider"), e;
      },
      b = function (e) {
        return '\n    <div class="ayfs-logo">\n      <a href="'
          .concat(
            e.youtube_channel.youtube_channel.url,
            '" target="_blank">\n        '
          )
          .concat(
            e.youtube_channel.youtube_channel.thumbnailCustom ||
              e.youtube_channel.youtube_channel.thumbnail
              ? '<img alt="'
                  .concat("Youtube Feed by Arena", '" src="')
                  .concat(
                    e.youtube_channel.youtube_channel.thumbnailCustom ||
                      e.youtube_channel.youtube_channel.thumbnail,
                    '"/>'
                  )
              : "",
            "\n      </a>\n    </div>\n  "
          );
      },
      _ = function (e) {
        return '\n    <div class="ayfs-subscribe-button">\n      <a href="'
          .concat(
            e.youtube_channel.youtube_channel.url,
            '?sub_confirmation=1" target="_blank">\n        <div class="youtube-logo">\n          '
          )
          .concat(
            '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 -77 512.00213 512"\n>\n  <g>\n    <path\n      xmlns="http://www.w3.org/2000/svg"\n      d="m501.453125 56.09375c-5.902344-21.933594-23.195313-39.222656-45.125-45.128906-40.066406-10.964844-200.332031-10.964844-200.332031-10.964844s-160.261719 0-200.328125 10.546875c-21.507813 5.902344-39.222657 23.617187-45.125 45.546875-10.542969 40.0625-10.542969 123.148438-10.542969 123.148438s0 83.503906 10.542969 123.148437c5.90625 21.929687 23.195312 39.222656 45.128906 45.128906 40.484375 10.964844 200.328125 10.964844 200.328125 10.964844s160.261719 0 200.328125-10.546875c21.933594-5.902344 39.222656-23.195312 45.128906-45.125 10.542969-40.066406 10.542969-123.148438 10.542969-123.148438s.421875-83.507812-10.546875-123.570312zm0 0"\n      fill="#ffffff"\n      data-original="#ff0000"\n    />\n    <path\n      xmlns="http://www.w3.org/2000/svg"\n      d="m204.96875 256 133.269531-76.757812-133.269531-76.757813zm0 0"\n      fill="#ff0000"\n      data-original="#ffffff"\n    />\n  </g>\n</svg>\n',
            "\n          <div>Youtube</div>\n        </div>\n      </a>\n      "
          )
          .concat(
            e.youtube_channel.youtube_channel.statistics.subscriberCount
              ? '<div class="subscribers-counter">\n            '.concat(
                  p(
                    e.youtube_channel.youtube_channel.statistics.subscriberCount
                  ),
                  "\n          </div>"
                )
              : "",
            "            \n    </div>\n  "
          );
      },
      x = function (e, t) {
        var n,
          o,
          i = document.getElementById(e.id),
          s = e.setting.layout.video.layout.selected,
          a = e.setting.layout.video.layout.data[s].toLowerCase(),
          c =
            parseInt(
              null === (n = e.setting.layout.video) || void 0 === n
                ? void 0
                : n.thumbnailHeight
            ) || 200;
        c < 0 && (c = 200);
        var l =
          parseInt(
            null === (o = e.setting.layout.video) || void 0 === o
              ? void 0
              : o.thumbnailWidth
          ) || 300;
        l < 0 && (l = 300);
        var r = document.createElement("DIV");
        r.className = "ayfs-video-card ayfs-video-card-"
          .concat(a, " ayfs-video-card-")
          .concat(e.setting.id);
        var d = document.createElement("DIV");
        (d.innerHTML =
          '\n    <iframe\n      title=""\n      width="100%"\n      height="100%"\n      src="https://www.youtube.com/embed/'.concat(
            1 === e.setting.type.selected ? t : t.id,
            '"\n      frameborder="0"\n      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"\n      allowfullscreen\n    ></iframe>\n  '
          )),
          (d.style.height = "".concat(c, "px"));
        var g = document.createElement("DIV");
        if (
          ((g.className = "thumbnail"),
          (g.style.backgroundImage =
            1 === e.setting.type.selected
              ? "url('https://i.ytimg.com/vi/".concat(t, "/hqdefault.jpg')")
              : "url('https://i.ytimg.com/vi/".concat(
                  t.id,
                  "/hqdefault.jpg')"
                )),
          (g.style.height = "".concat(c, "px")),
          "settings-6" === e.setting.id && (g.style.width = "".concat(l, "px")),
          e.setting.layout.video.elements.play_icon.show)
        ) {
          var u,
            m,
            h,
            y,
            b,
            _,
            x,
            C,
            I,
            S,
            k,
            D,
            L =
              null !== (u = e.setting.layout.video) &&
              void 0 !== u &&
              null !== (m = u.play_icon_custom) &&
              void 0 !== m &&
              m.value
                ? (null === (h = e.setting.layout.video) ||
                  void 0 === h ||
                  null === (y = h.play_icon_custom) ||
                  void 0 === y ||
                  null === (b = y.value) ||
                  void 0 === b
                    ? void 0
                    : b.indexOf(".png")) >= 0
                  ? '<img alt="" src="'.concat(
                      null === (_ = e.setting.layout.video) ||
                        void 0 === _ ||
                        null === (x = _.play_icon_custom) ||
                        void 0 === x
                        ? void 0
                        : x.value,
                      '" />'
                    )
                  : (null === (C = e.setting.layout.video) ||
                    void 0 === C ||
                    null === (I = C.play_icon_custom) ||
                    void 0 === I ||
                    null === (S = I.value) ||
                    void 0 === S
                      ? void 0
                      : S.indexOf("<svg")) >= 0
                  ? null === (k = e.setting.layout.video) ||
                    void 0 === k ||
                    null === (D = k.play_icon_custom) ||
                    void 0 === D
                    ? void 0
                    : D.value
                  : v
                : v,
            M = document.createElement("DIV");
          (M.className = "play-icon"), (M.innerHTML = L), g.appendChild(M);
        }
        if (
          (1 !== e.setting.layout.video.mode.selected
            ? r.appendChild(g)
            : r.appendChild(d),
          0 === e.setting.type.selected)
        ) {
          var O = document.createElement("DIV");
          (O.className = "title"), (O.textContent = t.snippet.title);
          var B = document.createElement("DIV");
          (B.className = "publish-time"),
            (B.textContent = w(t.snippet.publishedAt, "YYYY/MM/DD"));
          var T = document.createElement("DIV");
          (T.className = "description"),
            (T.textContent = t.snippet.description);
          var j = document.createElement("DIV");
          j.textContent = "".concat(p(t.statistics.viewCount), " Views");
          var N = document.createElement("DIV");
          N.textContent = "".concat(p(t.statistics.likeCount), " Likes");
          var V = document.createElement("DIV");
          V.textContent = "".concat(p(t.statistics.commentCount), " Comments");
          var A = document.createElement("DIV");
          (A.className = "statistics"),
            e.setting.layout.video.elements.views_counter.show &&
              A.appendChild(j),
            e.setting.layout.video.elements.views_counter.show &&
              e.setting.layout.video.elements.likes_counter.show &&
              A.appendChild(f()),
            e.setting.layout.video.elements.likes_counter.show &&
              A.appendChild(N),
            ((e.setting.layout.video.elements.views_counter.show &&
              e.setting.layout.video.elements.comments_counter.show) ||
              (e.setting.layout.video.elements.likes_counter.show &&
                e.setting.layout.video.elements.comments_counter.show)) &&
              A.appendChild(f()),
            e.setting.layout.video.elements.comments_counter.show &&
              A.appendChild(V);
          var Y = document.createElement("DIV");
          (Y.className = "video-infomation"),
            e.setting.layout.video.elements.title.show && Y.appendChild(O),
            e.setting.layout.video.elements.date.show && Y.appendChild(B),
            e.setting.layout.video.elements.description.show &&
              Y.appendChild(T),
            "settings-6" === e.setting.id && (Y.style.flex = 1),
            Y.appendChild(A),
            1 !== e.setting.layout.video.mode.selected
              ? r.appendChild(g)
              : r.appendChild(d),
            2 !== e.setting.layout.video.layout.selected &&
            1 !== e.setting.layout.video.mode.selected
              ? r.appendChild(Y)
              : (Y.style.visibility = "hidden"),
            "cinema" === a &&
              (r.addEventListener("mouseover", function () {
                (Y.style.opacity = 0.9), (Y.style.zIndex = 4);
              }),
              r.addEventListener("mouseout", function () {
                Y.style.zIndex = -1;
              }),
              r.addEventListener(
                "click",
                function () {
                  Y.style.zIndex = -1;
                },
                !0
              ));
          var P = document.createElement("script");
          P.setAttribute("type", "application/ld+json");
          var z = {
            "@context": "https://schema.org/",
            "@type": "VideoObject",
            name: t.snippet.title,
            description: t.snippet.description,
            uploadDate: t.snippet.publishedAt,
            thumbnailURL: [t.snippet.thumbnails.high.url],
            duration: t.contentDetails.duration,
            embedUrl: "https://www.youtube.com/embed/".concat(t.id),
          };
          (P.textContent = JSON.stringify(z)), document.head.appendChild(P);
        }
        return (
          r.addEventListener("click", function () {
            switch (e.setting.layout.video.mode.selected) {
              case 0:
                E(i, e, t);
                break;
              case 1:
                break;
              case 2:
                window.open(
                  "https://www.youtube.com/watch?v=".concat(t.id),
                  "_blank"
                );
                break;
              default:
                E(i, e, t);
            }
          }),
          r
        );
      },
      C = function (e) {
        var t = document.getElementById(e);
        t.removeChild(t.childNodes[t.childNodes.length - 1]),
          document
            .getElementsByTagName("BODY")[0]
            .classList.remove("yta-popup-show");
      };
    window.__handleShowMoreDescription = function (e) {
      var t = document.getElementById("video-popup-show-more-".concat(e)),
        n = document.getElementById(
          "video-popup-channel-description-".concat(e)
        );
      "SHOW MORE" === t.innerText
        ? ((t.textContent = "SHOW LESS"),
          (n.className =
            "channel-description-content channel-description-content-show-more"))
        : ((t.textContent = "SHOW MORE"),
          (n.className = "channel-description-content"));
    };
    var E = function (e, t, n) {
        if (
          1 == t.setting.type.selected &&
          0 == t.youtube_channel.youtube_videos.items.length
        ) {
          var o =
              '\n        <div class="ayfs-popup-wrapper">\n          <div class="ayfs-popup-margin"></div>\n          <div class="ayfs-popup-wrapper-body">\n            <div class="ayfs-popup-header" id="'
                .concat(t.id, '-popup-header">\n              ')
                .concat(
                  m,
                  '\n            </div>\n\n            <div class="ayfs-popup-body">\n              <div id="ayfs-popup-video-overlay" class="ayfs-popup-video-overlay">\n                <iframe\n                  title=""\n                  width="100%"\n                  height="100%"\n                  src="https://www.youtube.com/embed/'
                )
                .concat(
                  n,
                  '?autoplay=1"\n                  frameborder="0"\n                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"\n                  allowfullscreen\n                ></iframe>\n              </div>\n            </div>\n          </div>\n          <div class="ayfs-popup-margin"></div>\n        </div>\n      '
                ),
            i = new DOMParser().parseFromString(o, "text/html").body.firstChild;
          e.appendChild(i),
            document
              .getElementById("".concat(t.id, "-popup-header"))
              .addEventListener("click", function () {
                return C(t.id);
              });
          var s = document.getElementsByClassName("ayfs-popup-margin");
          Array.from(s).forEach(function (e) {
            return e.addEventListener("click", function () {
              return C(t.id);
            });
          });
        } else {
          var a =
              t.youtube_channel.youtube_channel.titleCustom ||
              t.youtube_channel.youtube_channel.title,
            c =
              t.youtube_channel.youtube_channel.descriptionCustom ||
              t.youtube_channel.youtube_channel.description;
          document
            .getElementsByTagName("BODY")[0]
            .classList.add("yta-popup-show");
          var l =
              '\n        <div class="ayfs-popup-wrapper">\n          <div class="ayfs-popup-margin"></div>\n          <div class="ayfs-popup-wrapper-body">\n            <div class="ayfs-popup-header" id="'
                .concat(t.id, '-popup-header">\n              ')
                .concat(
                  m,
                  '\n            </div>\n\n            <div class="ayfs-popup-body">\n              <div id="ayfs-popup-video-overlay" class="ayfs-popup-video-overlay">\n                <iframe\n                  title="'
                )
                .concat(
                  n.snippet.title,
                  '"\n                  width="100%"\n                  height="100%"\n                  src="https://www.youtube.com/embed/'
                )
                .concat(
                  n.id,
                  '?autoplay=1"\n                  frameborder="0"\n                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"\n                  allowfullscreen\n                ></iframe>\n              </div>\n\n              <div class="video-info">\n                  <div class="video-info-header">\n                      '
                )
                .concat(
                  t.setting.layout.popup.elements.title.show
                    ? '<div class="video-info-title">'.concat(
                        n.snippet.title,
                        "</div>"
                      )
                    : "",
                  "\n                      "
                )
                .concat(
                  t.setting.layout.popup.elements.description.show
                    ? '<div class="video-info-description" id="video-info-description"></div>'
                    : "",
                  '\n\n                      <div class="video-info-statistics">\n                          <div class="view-count">\n                              '
                )
                .concat(
                  t.setting.layout.popup.elements.views_counter.show
                    ? "<div>".concat(p(n.statistics.viewCount), " Views</div>")
                    : "",
                  '\n                              <div class="divider"></div>\n                              '
                )
                .concat(
                  t.setting.layout.popup.elements.date.show
                    ? '<div class="video-publish">\n                                      Published at '.concat(
                        w(n.snippet.publishedAt, "MM/DD/YYYY"),
                        "\n                                    </div>"
                      )
                    : "",
                  '\n                          </div>\n\n                          <div class="more">\n                              '
                )
                .concat(
                  t.setting.layout.popup.elements.likes_counter.show
                    ? '<div class="likes-count">\n                                      '
                        .concat(
                          y,
                          "\n                                      <div>\n                                        "
                        )
                        .concat(
                          p(n.statistics.likeCount),
                          "\n                                      </div>\n                                    </div>"
                        )
                    : "",
                  "\n                              "
                )
                .concat(
                  t.setting.layout.popup.elements.dislikes_counter.show
                    ? '<div class="dislikes-count">\n                                      '
                        .concat(
                          h,
                          "\n                                      <div>\n                                        "
                        )
                        .concat(
                          p(n.statistics.dislikeCount),
                          "\n                                      </div>\n                                    </div>"
                        )
                    : "",
                  "\n                              "
                )
                .concat(
                  t.setting.layout.popup.elements.share_button.show
                    ? '<div class="share">\n                                      '.concat(
                        '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 -22 512 511"\n>\n  <g>\n    <path\n      xmlns="http://www.w3.org/2000/svg"\n      d="m512 233.820312-212.777344-233.320312v139.203125h-45.238281c-140.273437 0-253.984375 113.710937-253.984375 253.984375v73.769531l20.09375-22.019531c68.316406-74.851562 164.980469-117.5 266.324219-117.5h12.804687v139.203125zm0 0"\n      fill="#888888"\n      data-original="#000000"\n    />\n  </g>\n</svg>\n',
                        '\n                                      <div class="content">SHARE</div>\n                                    </div>'
                      )
                    : "",
                  "\n                          </div>\n                      </div>\n                  </div>\n\n                  "
                )
                .concat(
                  t.youtube_channel.youtube_channel.title ||
                    t.youtube_channel.youtube_channel.titleCustom
                    ? '<div class="channel-info">\n                          '
                        .concat(
                          t.setting.layout.popup.elements.channel_logo.show
                            ? b(t)
                            : "",
                          '\n\n                          <div class="channel-info-more">\n                              '
                        )
                        .concat(
                          t.setting.layout.popup.elements.channel_name.show &&
                            '<div class="channel-name">\n                                  <a href="'
                              .concat(
                                t.youtube_channel.youtube_channel.url,
                                '" target="_blank">\n                                    '
                              )
                              .concat(
                                a,
                                "\n                                  </a>\n                                </div>"
                              ),
                          "\n                              "
                        )
                        .concat(
                          t.setting.layout.popup.elements.description.show
                            ? '<div class="channel-description">\n                                      <div id="video-popup-channel-description-'
                                .concat(
                                  n.id,
                                  '" class="channel-description-content"></div>\n                                      '
                                )
                                .concat(
                                  t.setting.layout.popup.elements
                                    .description_more_button.show
                                    ? '<span id="video-popup-show-more-'
                                        .concat(
                                          n.id,
                                          '" class="show-more" onclick="window.__handleShowMoreDescription(\''
                                        )
                                        .concat(
                                          n.id,
                                          "')\">\n                                              SHOW MORE\n                                            </span>"
                                        )
                                    : "",
                                  "\n                                  </div>"
                                )
                            : "",
                          "\n                          </div>\n\n                          "
                        )
                        .concat(
                          t.setting.layout.popup.elements.subcribe_button.show
                            ? _(t)
                            : "",
                          "\n                        </div>"
                        )
                    : "",
                  "\n              </div>\n\n              "
                )
                .concat(
                  t.app_plan &&
                    "basic" != t.app_plan &&
                    n.comments &&
                    n.comments.length > 0
                    ? '\n                  <div id="ayfs-popup-comments" class="ayfs-popup-comments">\n                    <div class="ayfs-popup-comments-count">'.concat(
                        n.statistics.commentCount,
                        " comments</div>\n                  </div>\n                  "
                      )
                    : null,
                  '\n            </div>\n          </div>\n          <div class="ayfs-popup-margin"></div>\n        </div>\n      '
                ),
            r = new DOMParser().parseFromString(l, "text/html").body.firstChild;
          e.appendChild(r),
            document
              .getElementById("".concat(t.id, "-popup-header"))
              .addEventListener("click", function () {
                return C(t.id);
              });
          var d = document.getElementsByClassName("ayfs-popup-margin");
          Array.from(d).forEach(function (e) {
            return e.addEventListener("click", function () {
              return C(t.id);
            });
          });
          var g = document.getElementById("video-info-description");
          g &&
            n.snippet.description.split("\n").forEach(function (e) {
              if (e) {
                var t = document.createElement("DIV");
                (t.innerHTML = e), g.appendChild(t);
              }
            });
          var u = document.getElementById(
            "video-popup-channel-description-".concat(n.id)
          );
          u &&
            c.split("\n").forEach(function (e) {
              if (e) {
                var t = document.createElement("DIV");
                (t.innerHTML = e), u.appendChild(t);
              }
            });
          var v = document.getElementById("ayfs-popup-comments");
          if (v) {
            n.comments.forEach(function (e) {
              if (e) {
                var t = document.createElement("DIV");
                (t.innerHTML =
                  '\n    <div class="yta-popup-comments-item">\n      <div class="yta-popup-comments-user-avatar" onclick="window.open(\''
                    .concat((n = e).snippet.authorChannelUrl, "')\">\n        ")
                    .concat(
                      n.snippet.authorProfileImageUrl
                        ? '<img alt="'
                            .concat(n.snippet.authorDisplayName, '" src="')
                            .concat(n.snippet.authorProfileImageUrl, '" />')
                        : null,
                      '\n      </div>\n      <div class="yta-popup-comments-details">\n        <div class="yta-popup-comments-details-head">\n          <div class="yta-popup-comments-user-name" onclick="window.open(\''
                    )
                    .concat(n.snippet.authorChannelUrl, "')\">")
                    .concat(
                      n.snippet.authorDisplayName,
                      '</div>\n          <div class="yta-popup-comments-timestamp">'
                    )
                    .concat(
                      w(n.snippet.publishedAt),
                      '</div>\n        </div>\n        <div class="yta-popup-comments-content">'
                    )
                    .concat(
                      n.snippet.textDisplay,
                      '</div>\n        <div class="yta-popup-comments-actions">\n          <div class="yta-popup-comments-like">\n            '
                    )
                    .concat(
                      y,
                      '\n            <div class="yta-popup-comments-like-count">'
                    )
                    .concat(
                      p(n.snippet.likeCount),
                      '</div>\n          </div>\n          <div class="yta-popup-comments-dislike">\n            '
                    )
                    .concat(
                      h,
                      '\n            <div class="yta-popup-comments-dislike-count">0</div>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
                    )),
                  v.appendChild(t);
              }
              var n;
            });
            var f = document.createElement("DIV");
            (f.innerHTML =
              '<div class="ayfs-popup-comments-show-more" onclick="window.open(\'https://www.youtube.com/watch?v='
                .concat(n.id, "')\">Show more ")
                .concat(
                  n.statistics.commentCount - n.comments.length,
                  " comments..</div>"
                )),
              v.appendChild(f);
          }
        }
        document
          .getElementsByTagName("BODY")[0]
          .classList.add("yta-popup-show");
      },
      I = function (e) {
        var t,
          n,
          o,
          i,
          s = document.getElementById(e.id),
          a =
            parseInt(
              null === (t = e.setting.layout) ||
                void 0 === t ||
                null === (n = t.margin) ||
                void 0 === n
                ? void 0
                : n.vertical_margin
            ) || 0,
          c =
            parseInt(
              null === (o = e.setting.layout) ||
                void 0 === o ||
                null === (i = o.margin) ||
                void 0 === i
                ? void 0
                : i.horizontal_margin
            ) || 0;
        if (s) {
          (s.className = "ayfs"),
            (s.innerHTML = ""),
            (s.style.margin = "".concat(a, "px ").concat(c, "px"));
          var l = [];
          (l =
            1 == e.setting.type.selected
              ? e.youtube_channel.youtube_videos.ids
              : e.youtube_channel.youtube_videos.items),
            e.setting.layout.header.show &&
              e.setting.layout.header.elements.banner.show &&
              "{}" !== JSON.stringify(e.youtube_channel.youtube_channel) &&
              (function (e, t) {
                var n =
                  t.youtube_channel.youtube_channel.imageCustom ||
                  t.youtube_channel.youtube_channel.image;
                if (t.setting.layout.header.show && n) {
                  var o = document.createElement("DIV");
                  (o.className = "ayfs-banner"),
                    (o.style.backgroundImage = "url('".concat(n, "')")),
                    e.appendChild(o);
                }
              })(s, e),
            e.setting.layout.header.show &&
              "{}" !== JSON.stringify(e.youtube_channel.youtube_channel) &&
              (function (e, t) {
                var n =
                    t.youtube_channel.youtube_channel.titleCustom ||
                    t.youtube_channel.youtube_channel.title,
                  o =
                    t.youtube_channel.youtube_channel.descriptionCustom ||
                    t.youtube_channel.youtube_channel.description,
                  i = t.setting.layout.header.layout.selected,
                  s = t.setting.layout.header.layout.data[i].toLowerCase(),
                  a = '\n        <div class="ayfs-header ayfs-header-'
                    .concat(s, '">\n            ')
                    .concat(
                      t.setting.layout.header.elements.logo.show ? b(t) : "",
                      '\n\n            <div class="header-information">\n              '
                    )
                    .concat(
                      t.setting.layout.header.elements.channel_name.show
                        ? '<div class="channel-name">\n                      <a href="'
                            .concat(
                              t.youtube_channel.youtube_channel.url,
                              '" target="_blank">\n                        '
                            )
                            .concat(
                              n,
                              "\n                      </a>\n                    </div>"
                            )
                        : "",
                      '\n\n              <div class="information-counter">\n                  '
                    )
                    .concat(
                      t.setting.layout.header.elements.subscribers_counter.show
                        ? "<div>".concat(
                            p(
                              t.youtube_channel.youtube_channel.statistics
                                .subscriberCount
                            ),
                            " Subscribers</div>"
                          )
                        : "",
                      "\n\n                  "
                    )
                    .concat(
                      t.setting.layout.header.elements.subscribers_counter
                        .show &&
                        t.setting.layout.header.elements.videos_counter.show
                        ? '<div class="divider"></div>'
                        : "",
                      "\n\n                  "
                    )
                    .concat(
                      t.setting.layout.header.elements.videos_counter.show
                        ? "<div>".concat(
                            p(
                              t.youtube_channel.youtube_channel.statistics
                                .videoCount
                            ),
                            " Videos</div>"
                          )
                        : "",
                      "\n\n                  "
                    )
                    .concat(
                      (t.setting.layout.header.elements.videos_counter.show &&
                        t.setting.layout.header.elements.views_counter.show) ||
                        (t.setting.layout.header.elements.subscribers_counter
                          .show &&
                          t.setting.layout.header.elements.views_counter.show)
                        ? '<div class="divider"></div>'
                        : "",
                      "\n\n                  "
                    )
                    .concat(
                      t.setting.layout.header.elements.views_counter.show
                        ? "<div>".concat(
                            p(
                              t.youtube_channel.youtube_channel.statistics
                                .viewCount
                            ),
                            " Views</div>"
                          )
                        : "",
                      "\n              </div>\n\n              "
                    )
                    .concat(
                      t.setting.layout.header.elements.channel_description.show
                        ? '<div class="channel-description" id="yta-channel-description-'.concat(
                            t.id,
                            '"></div>'
                          )
                        : "",
                      "\n            </div>\n\n            "
                    )
                    .concat(
                      t.setting.layout.header.elements.subcribe_button.show
                        ? _(t)
                        : "",
                      "\n        </div>\n    "
                    ),
                  c = new DOMParser().parseFromString(a, "text/html").body
                    .firstChild;
                e.appendChild(c);
                var l = document.getElementById(
                  "yta-channel-description-".concat(t.id)
                );
                l &&
                  o.split("\n").forEach(function (e) {
                    if (e) {
                      var t = document.createElement("DIV");
                      (t.innerHTML = e), l.appendChild(t);
                    }
                  });
              })(s, e),
            l.length &&
              (function (e, t) {
                try {
                  var n = parseInt(t.setting.layout.columns_rows.columns) || 1;
                  n < 0 && (n = 1);
                  var o = parseInt(t.setting.layout.columns_rows.rows) || 1;
                  o < 0 && (o = 1);
                  var i =
                    parseInt(t.setting.layout.slider_settings.video_count) || 1;
                  i < 0 && (i = 1);
                  var s =
                    parseInt(
                      t.setting.layout.columns_rows.space_between_videos
                    ) || 0;
                  s < 0 && (s = 0);
                  var a =
                    parseInt(
                      t.setting.layout.slider_settings.silde_switch_speed
                    ) || 400;
                  a < 0 && (a = 400);
                  var c = 0;
                  c =
                    1 == t.setting.type.selected
                      ? t.youtube_channel.youtube_videos.ids.length < i
                        ? t.youtube_channel.youtube_videos.ids.length
                        : i
                      : t.youtube_channel.youtube_videos.items.length < i
                      ? t.youtube_channel.youtube_videos.items.length
                      : i;
                  var l = [];
                  l =
                    1 == t.setting.type.selected
                      ? t.youtube_channel.youtube_videos.ids.slice(0, c)
                      : t.youtube_channel.youtube_videos.items.slice(0, c);
                  var r = document.createElement("DIV");
                  r.className = "yt-feed-slider";
                  for (var d = 0; d < l.length / o; d++) {
                    var g = document.createElement("DIV");
                    g.className = "video-list-column";
                    for (var u = 0; u < o; u++)
                      if (l[d * o + u]) {
                        var p = document.createElement("DIV");
                        (p.className = "video-list-item"),
                          o > 1 && (p.style.paddingBottom = "".concat(s, "px")),
                          p.appendChild(x(t, l[d * o + u])),
                          g.appendChild(p);
                      }
                    r.appendChild(g);
                  }
                  var w = document.createElement("DIV");
                  (w.className = "ayfs-videos-playlist"),
                    w.appendChild(r),
                    e.appendChild(w);
                  var v =
                    parseInt(
                      t.setting.layout.slider_settings.mobile_responsive
                        .extra_small.value
                    ) || 1;
                  v < 0 && (v = 1);
                  var m =
                    parseInt(
                      t.setting.layout.slider_settings.mobile_responsive.small
                        .value
                    ) || 1;
                  m < 0 && (m = 1);
                  var h =
                    parseInt(
                      t.setting.layout.slider_settings.mobile_responsive.medium
                        .value
                    ) || 1;
                  h < 0 && (h = 1);
                  var y =
                    parseInt(
                      t.setting.layout.slider_settings.mobile_responsive.large
                        .value
                    ) || 1;
                  y < 0 && (y = 1);
                  var f =
                    parseInt(
                      t.setting.layout.slider_settings.mobile_responsive
                        .extra_large.value
                    ) || 1;
                  f < 0 && (f = 1);
                  var b = window.tns
                    ? tns({
                        container: "#".concat(t.id, " .yt-feed-slider"),
                        items: 1,
                        edgePadding: t.setting.layout.slider_settings
                          .mobile_responsive_edge_padding.enabled
                          ? t.setting.layout.slider_settings
                              .mobile_responsive_edge_padding.value
                          : 0,
                        slideBy: "page",
                        mouseDrag: !0,
                        swipeAngle: !1,
                        loop: !0,
                        autoplay:
                          t.setting.layout.slider_settings.slide_auto_play &&
                          1 !== t.setting.layout.video.mode.selected,
                        speed: a,
                        responsive:
                          "settings-3" !== t.setting.id &&
                          "settings-6" !== t.setting.id
                            ? {
                                375: {
                                  items: n < v ? n : v,
                                  edgePadding: t.setting.layout.slider_settings
                                    .mobile_responsive_edge_padding.enabled
                                    ? t.setting.layout.slider_settings
                                        .mobile_responsive_edge_padding.value
                                    : 0,
                                },
                                576: {
                                  items: n < m ? n : m,
                                  edgePadding: t.setting.layout.slider_settings
                                    .mobile_responsive_edge_padding.enabled
                                    ? t.setting.layout.slider_settings
                                        .mobile_responsive_edge_padding.value
                                    : 0,
                                },
                                768: {
                                  items: n < h ? n : h,
                                  edgePadding: t.setting.layout.slider_settings
                                    .mobile_responsive_edge_padding.enabled
                                    ? t.setting.layout.slider_settings
                                        .mobile_responsive_edge_padding.value
                                    : 0,
                                },
                                992: {
                                  items: n < y ? n : y,
                                  edgePadding: t.setting.layout.slider_settings
                                    .mobile_responsive_edge_padding.enabled
                                    ? t.setting.layout.slider_settings
                                        .mobile_responsive_edge_padding.value
                                    : 0,
                                },
                                1200: {
                                  items: n < f ? n : f,
                                  edgePadding: t.setting.layout.slider_settings
                                    .mobile_responsive_edge_padding.enabled
                                    ? t.setting.layout.slider_settings
                                        .mobile_responsive_edge_padding.value
                                    : 0,
                                },
                              }
                            : {
                                375: { items: n },
                                576: { items: n },
                                768: { items: n },
                                992: { items: n },
                                1200: { items: n },
                              },
                        gutter: s,
                        axis:
                          "settings-6" === t.setting.id
                            ? "vertical"
                            : "horizontal",
                        autoplayButton: !1,
                        nav: !1,
                        autoplayButtonOutput: !1,
                        controls: !1,
                      })
                    : null;
                  window.slider = b;
                  var _ = document.createElement("DIV");
                  (_.className = "ayfs-pagi-btn ayfs-pagi-btn-".concat(
                    0 === t.setting.layout.slider_settings.direction.selected
                      ? "previous"
                      : "up"
                  )),
                    (_.innerHTML =
                      0 === t.setting.layout.slider_settings.direction.selected
                        ? '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 492 492"\n>\n  <g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"\n          fill="#111111"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n  </g>\n</svg>\n'
                        : '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 492.002 492.002"\n>\n  <g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M484.136,328.473L264.988,109.329c-5.064-5.064-11.816-7.844-19.172-7.844c-7.208,0-13.964,2.78-19.02,7.844    L7.852,328.265C2.788,333.333,0,340.089,0,347.297c0,7.208,2.784,13.968,7.852,19.032l16.124,16.124    c5.064,5.064,11.824,7.86,19.032,7.86s13.964-2.796,19.032-7.86l183.852-183.852l184.056,184.064    c5.064,5.06,11.82,7.852,19.032,7.852c7.208,0,13.96-2.792,19.028-7.852l16.128-16.132    C494.624,356.041,494.624,338.965,484.136,328.473z"\n          fill="#111111"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n  </g>\n</svg>\n');
                  var C = document.createElement("DIV");
                  (C.className = "ayfs-pagi-btn ayfs-pagi-btn-".concat(
                    0 === t.setting.layout.slider_settings.direction.selected
                      ? "next"
                      : "down"
                  )),
                    (C.innerHTML =
                      0 === t.setting.layout.slider_settings.direction.selected
                        ? '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 492.004 492.004"\n>\n  <g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"\n          fill="#111111"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n  </g>\n</svg>\n'
                        : '\n<svg\n  xmlns="http://www.w3.org/2000/svg"\n  version="1.1"\n  width="512"\n  height="512"\n  x="0"\n  y="0"\n  viewBox="0 0 491.996 491.996"\n>\n  <g>\n    <g xmlns="http://www.w3.org/2000/svg">\n      <g>\n        <path\n          d="M484.132,124.986l-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86c-7.208,0-13.964,2.792-19.036,7.86l-183.84,183.848    L62.056,108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968,2.788-19.036,7.856l-16.12,16.128    c-10.496,10.488-10.496,27.572,0,38.06l219.136,219.924c5.064,5.064,11.812,8.632,19.084,8.632h0.084    c7.212,0,13.96-3.572,19.024-8.632l218.932-219.328c5.072-5.064,7.856-12.016,7.864-19.224    C491.996,136.902,489.204,130.046,484.132,124.986z"\n          fill="#111111"\n          data-original="#000000"\n        />\n      </g>\n    </g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n    <g xmlns="http://www.w3.org/2000/svg"></g>\n  </g>\n</svg>\n'),
                    t.setting.layout.slider_settings.elements
                      .show_navigation_arrows.show &&
                      (w.appendChild(_),
                      w.appendChild(C),
                      _.addEventListener("click", function () {
                        return b.goTo("prev");
                      }),
                      C.addEventListener("click", function () {
                        return b.goTo("next");
                      }));
                } catch (e) {
                  console.log(e);
                }
              })(s, e),
            (function (e) {
              var t,
                n = e.setting.colors.items[e.setting.colors.selected],
                o = document.querySelector("#".concat(e.id, " .ayfs-header"));
              o &&
                (o.style.background =
                  null !== (t = n.items.header) &&
                  void 0 !== t &&
                  t.backgroundTransparent
                    ? "transparent"
                    : n.items.header.background.value);
              var i = document.querySelector(
                "#".concat(e.id, " .ayfs-header .channel-name a")
              );
              i && (i.style.color = n.items.header.channel_name.value);
              var s = document.querySelector(
                "#".concat(e.id, " .ayfs-header .channel-description")
              );
              s && (s.style.color = n.items.header.channel_description.value);
              var a = document.querySelector(
                "#".concat(e.id, " .ayfs-header .information-counter")
              );
              a && (a.style.color = n.items.header.header_counters.value);
              var c = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-header .divider")
              );
              c &&
                c.length > 0 &&
                c.forEach(function (e) {
                  return (e.style.backgroundColor =
                    n.items.header.header_counters.value);
                });
              var l = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-video-card .title")
              );
              l && l.length,
                l.forEach(function (e) {
                  return (e.style.color = n.items.video.video_title.value);
                });
              var r = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-video-card .publish-time")
              );
              r &&
                r.length > 0 &&
                r.forEach(function (e) {
                  return (e.style.color = n.items.video.video_date.value);
                });
              var d = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-video-card .description")
              );
              d &&
                d.length > 0 &&
                d.forEach(function (e) {
                  return (e.style.color =
                    n.items.video.video_description.value);
                });
              var g = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-video-card .statistics")
              );
              g &&
                g.length > 0 &&
                g.forEach(function (e) {
                  return (e.style.color = n.items.video.video_counters.value);
                });
              var u = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-video-card .duration")
              );
              u &&
                u.length > 0 &&
                u.forEach(function (e) {
                  (e.style.color = n.items.video.video_duration_color.value),
                    (e.style.backgroundColor =
                      n.items.video.video_duration_background.value);
                });
              var p = document.querySelectorAll(
                "#".concat(e.id, " .ayfs-video-card .divider")
              );
              p &&
                p.length > 0 &&
                p.forEach(function (e) {
                  return (e.style.backgroundColor =
                    n.items.video.video_counters.value);
                });
              var w = document.querySelector(
                "#".concat(e.id, " .ayfs-videos-playlist")
              );
              w &&
                (w.style.backgroundColor = n.items.slider.backgroundTransparent
                  ? "transparent"
                  : n.items.slider.background.value);
            })(e);
        }
      },
      S = function () {
        window.theme = window.theme || {};
        var e = window.theme.yta_widgets || [];
        e.length
          ? e.forEach(function (e) {
              e &&
                "{}" !== JSON.stringify(e) &&
                e.enabled &&
                document.getElementById(e.id) &&
                I(e);
            })
          : window.slider && slider.destroy();
      };
    window.addEventListener("load", function () {
      return S();
    }),
      (window.theme = window.theme || {}),
      (window.theme.renderYoutubeFeed = S),
      (theme.CustomType = function () {
        setTimeout(function () {
          window.theme.renderYoutubeFeed();
        }, 100);
      }),
      window.addEventListener("DOMContentLoaded", function () {
        !(function (e, t) {
          if ("string" != typeof e)
            throw new TypeError(
              "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
            );
          if (void 0 !== i[e])
            throw new Error(
              'Theme Sections: A section of type "' +
                e +
                '" has already been registered. You cannot register the same section type twice'
            );
          function n(e) {
            o.call(this, e, t);
          }
          (n.constructor = o),
            (n.prototype = Object.create(o.prototype)),
            (n.prototype.type = e),
            (i[e] = n);
        })("arena-youtube-feed", {
          onLoad: function () {
            theme.CustomType();
          },
        }),
          a("arena-youtube-feed");
      });
  },
]);
